import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/scan';

import { ChatbotService } from '../../shared/services/chatbot.service';
import { Message } from '../../shared/model/chatbot.message.model';
import { CHATBOT_NAME } from '../../shared/constants/chatbot-constants';
import * as $ from 'jquery';
import { DomElementSchemaRegistry } from '@angular/compiler';

@Component({
  selector: 'app-chatbot-dialog',
  templateUrl: './chatbot-dialog.component.html',
  styleUrls: ['./chatbot-dialog.component.css']
})
export class ChatbotDialogComponent implements OnInit {
  @ViewChild('chatbotConversationDiv') chatbotChatContainerElement; 

  chatbotName: string = CHATBOT_NAME;

  messages: Observable<Message[]>;
  formValue: string = '';
  firstScrollOcurrence: boolean = false;

  constructor(private chatbotService: ChatbotService) { }

  ngOnInit() {
    this.messages = this.chatbotService.conversation.asObservable()
      .scan((acc, val) => acc.concat(val));
  }

  sendMessage() {
    // Validate empty messages
    if(!$('#chatbotMsgInput').val()){
      console.log('empty message');
      return;
    }

    this.chatbotService.converse(this.formValue);
    this.formValue = '';

    // call auto-scroll to be applied in conversation container
    if(!this.firstScrollOcurrence){
      this.chatbotHistoryInitScroll();
    }
  }

  /** 
   * Auto-scroll down the chat history window
   * -  This function sets the scrollTop on the chat history container 
   *    and force it to scroll down till the bottom.  
   * -  This function is triggered until the first scroll event ocurrs,
   *    so it can trigger 'chatbotHistoryScroll' for any consecutive scroll event.
   */
  chatbotHistoryInitScroll(){
    $('#chatbotConversationCntr').animate({
      scrollTop: $('#chatbotConversationCntr').get(0).scrollHeight
    }, 100);
  } 

  /**
   * Auto-scroll down the chat history window
   * - This function is listen for a scroll event to set the scrollTop 
   * on the chat history container and force it to scroll down till the bottom 
   */ 
  chatbotHistoryScroll(event){
    this.firstScrollOcurrence = true;

    $("body").on('DOMSubtreeModified', "#chatbotConversationCntr", function() {
      $('#chatbotConversationCntr').scrollTop($('#chatbotConversationCntr').get(0).scrollHeight);
    });
  }

  /** 
   * Hide Chatbot Main Container 
   * - Main controller is located in app.component.html
   */
  collapseChatbotMainCntr(){
    $( "#chatbotMainContainer" ).fadeToggle( "slow", "linear" );
    $("#chatbotMainContainerBtn").show(2000); 
  }

}



// WEBPACK FOOTER //
// ./src/app/chatbot/chatbot-dialog/chatbot-dialog.component.ts